"use strict";
angular.module("internal.exams").controller("InternalExamViewsPermission", ["$scope",
    "Queries",
    "$state",
    "$stateParams",
    function ($scope, Queries, $state, $stateParams) {
        $scope.availableViewGroups = [];
        $scope.availableEditGroups = [];
        $scope.saveMessage = $stateParams.saveMessage;
        Queries.getSecurityGroups().then(function (securityGroups) {
            $scope.availableViewGroups = securityGroups;
            $scope.availableEditGroups = securityGroups;
        });
        $scope.save = function () {
            $scope.saving = true;
            $scope.query.query_page_id = '581C08D3-089F-4AAF-A95A-662C48A56983'
            // Accomodate strange naming of header in [Query_Filter_Values] and[Query_Advanced_Filter_Values]
            $scope.query.query_filter_values.forEach(function (query_filter_value) {
                query_filter_value.display_label = query_filter_value.name;
            })
            $scope.query.query_advanced_filter_values.forEach(function (query_advanced_filter_value) {
                query_advanced_filter_value.label = query_advanced_filter_value.name;
            })
            Queries.save($scope.query).then(function (query) {
                if (query != null) {
                    $state.go("internal.exams.administrative.internalview.permission", {
                        queryId: $scope.queryId,
                        query: query,
                        saveMessage: "Record updated successfully"
                    }, {
                        reload: "internal.exams.administrative.internalview"
                    });
                } else {
                    $scope.saveMessage = "Error: Save failed";
                    $window.scrollTo(0, 0);
                    $scope.saving = false;
                }
            });
        };
    }]);